module.exports = __webpack_public_path__ + "img/main_mancharo.41badb0f.jpg";